import { Box } from "@mui/material";
import { OutlinedButton, TextButton } from "../components/Button/AppButton";
import { DamsAppAsset } from "../assets/registry";
import { useRef, useState } from "react";
import { grey } from "@mui/material/colors";
import { BadgeLabel } from "../components/Label";
import { useCloseModal } from "../hooks/useCloseModal";
interface FilterModalProps {
  children: React.ReactNode;
  label: string;
  loading: boolean;
  closeOnoutSideClick?: boolean;
}
export const FilterModal = ({
  children,
  label,
  loading,
  closeOnoutSideClick,
}: FilterModalProps) => {
  const [open, setOpen] = useState(false);
  const modalRef = useRef(null);
  useCloseModal(
    modalRef,
    () => setOpen(false),
    "click",
    closeOnoutSideClick ?? false
  );
  return (
    <Box ref={modalRef}>
      {/* <OutlinedButton
        onClick={() => setOpen(!open)}
        title={label}
        height={40}
        width={140}
        iconPosition={"left"}
        iconAnchorLoading={loading}
        btnIconSrc={DamsAppAsset.icons.filter_lines}
      /> */}
      <TextButton
        height={40}
        title={label}
        btnIconSrc={DamsAppAsset.icons.filter}
        iconAnchorLoading={loading}
        onClick={() => setOpen(!open)}
      />
      {open && (
        <Box sx={styles.model}>
          {children}
          <Box marginTop={2}>
            <BadgeLabel
              isLarge
              title="close"
              onClick={() => setOpen(false)}
              colorType="blue"
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};
const styles = {
  model: {
    zIndex: 100,
    position: "absolute",
    backgroundColor: grey[50],
    border: `1px solid ${grey[300]}`,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: 2,
    paddingBottom: 2,
    borderRadius: 2,
    marginTop: 1,
    boxShadow:
      "rgba(0, 0, 0, 0.07) 0px 1px 1px, rgba(0, 0, 0, 0.07) 0px 2px 2px, rgba(0, 0, 0, 0.07) 0px 4px 4px, rgba(0, 0, 0, 0.07) 0px 8px 8px, rgba(0, 0, 0, 0.07) 0px 16px 16px",
  },
};
